import { Injectable, Injector } from "@angular/core";
import { FormlyFieldConfig } from "@ngx-formly/core";
import { WidgetsAbstract } from "src/app/abstract/widgets/widgets.abstract";
import { Logger } from "src/app/core/logger";
import { WidgetsArrayModel } from "src/app/models/widgets/widgets-array.model";
import { RenderService } from "./render.service";
import { v4 as uuidv4 } from 'uuid';
import { AbstractRender } from "src/app/abstract/render.abstract";

@Injectable({
  providedIn: 'root'
})
export class RenderArrayService extends AbstractRender {
  constructor( private injector: Injector,
    private logger: Logger) {
    super();
  }

  /**
   * Recursive render method
   *
   * @param widget A layout node
   * @param config Formly field config array
   * @param widgetRoot Root of the layout
   * @param formlyRoot Root of the FormlyFieldConfig
   * @param isInsideQuestion True if we are rendering a subtree inside a question
   * @param isRecursive True if we want to traverse the tree to the bottom. False if we just want to render a node.
   */
  render(widget: WidgetsAbstract,
    config: FormlyFieldConfig[],
    widgetRoot: WidgetsAbstract,
    formlyRoot: FormlyFieldConfig,
    isInsideQuestion: boolean,
    isRecursive: boolean,
  ) {

    let field: FormlyFieldConfig;

    try {
        if (widget instanceof WidgetsArrayModel) {
          const currentWidget = widget as WidgetsArrayModel;

          field = {
            type: 'repeat',
            key: uuidv4(),
            fieldArray: {
              fieldGroup: [],
            },
          };

          config.push(field);

          if (isRecursive) {

            const renderService = this.injector.get(RenderService);
            currentWidget.children.forEach(childWidget => {
              // eslint-disable-next-line
              renderService.render(childWidget, field.fieldGroup!, widgetRoot, formlyRoot, isInsideQuestion, isRecursive);
            });

          }

        }
    }
    catch (error) {
        this.logger.log(error);
    }

  }
}

